<template>
  <v-container style="width: 900px">
    <v-data-table
        :headers="tableHeaders"
        :items="estimationItems"
        :loading="loading"
    >
      <template v-slot:item="{item}">
        <tr
            class="text-left"
            :class="{'grey lighten-3 grey--text': item.selected}"
        >
          <td>
            {{ item.number + ' ' + item.name }}
          </td>
          <td>
            {{ item.quantity }}
          </td>
          <td>
            {{ languageData.measureTypes[item.uom.value] }}
          </td>
          <td>
            {{ item.price }}
          </td>
          <td>
            {{ parseFloat(item.totalNet).toFixed(2) }}
          </td>
          <td>
            <template v-if="showVat === true">
              {{ typeof (item.vat) === "object" ? languageData.vatLabels[item.vat.label] : languageData.vatLabels[item.label]}}
            </template>
            <template v-else>
              &ndash;
            </template>
          </td>
          <td>
            <template v-if="showVat === true">
              {{ parseFloat(item.vatCost).toFixed(2) }}
            </template>
            <template v-else>
              &ndash;
            </template>
          </td>

          <td>
            <template v-if="showVat === true">
              {{ parseFloat(item.totalGross).toFixed(2) }}
            </template>
            <template v-else>
              {{ parseFloat(item.totalNet).toFixed(2) }}
            </template>
          </td>
          <td>
            <v-btn
                :disabled="item.selected"
                @click="addEstimationItem(item)"
                icon>
              <v-icon color="primary">add</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script type="text/javascript">
import {mapState} from 'vuex';
import eventBus from "../../../../event-bus/eventBus";
import moneyCalculationsHelper from "../../../../helpers/moneyCalculationsHelper";

export default {
  props: {
    layout: String,
    tableHeaders: Array,
    invoiceItems: Array,
    showVat: Boolean,
  },
  data() {
    return {
      selectedEstimations: [],
      moneyCalculationsHelper: moneyCalculationsHelper
    }
  },
  computed: {
    ...mapState("getEstimate", {
      estimations: state => state.estimationsData
    }),
    ...mapState("getEstimate", {
      loading: state => state.dataGetEstimationsFetching
    }),
    ...mapState("getVat", {
      vatData: state => state.vat
    }),
    estimationItems() {
      return this.flattenedEstimations(this.estimations);
    },
  },

  methods: {
    flattenedEstimations(arr) {
      let children = [];
      const flattenMembers = arr.map(m => {
        if (m.children && m.children.length) {
          children = [...children, ...m.children];
        }
        return m;
      });
      let flattenArr = flattenMembers.concat(children.length ? this.flattenedEstimations(children) : children)

      flattenArr.forEach((el) => { // determine if estimation item is in invoiceItems
        return this.invoiceItems.find(x => x.id === el.id && !x.isMeasurement) ? el.selected = true : el.selected = false;
      });

      return flattenArr.filter((e) => {
          if(typeof (e.vat) === 'object') {
            e.totalNet = this.moneyCalculationsHelper.itemTotalNetProduct(e.price, e.quantity);
            e.vatCost = this.moneyCalculationsHelper.itemVatCost(e.totalNet, this.showVat && e.vat != null ? e.vat.value : 0);
            e.totalGross = this.moneyCalculationsHelper.itemTotalGrossProduct(e.totalNet, e.vatCost); 
          } else {
            e.vat = this.vatData.find(({value}) => value == e.vat);
          }

        return e.visibleInput === true; // determine if estimation has visible inputs
      });
    },
    addEstimationItem(item) {
      eventBus.$emit('addEstimationItem', {item});
    },
    flattenedEstimationItems() {
      return this.flattenedEstimations(this.estimations)
    },
  },

}
</script>